var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('transition',{attrs:{"name":"fade-in"}},[_c('div',{staticClass:"message-notice",class:_vm.type ? 'message-notice--' + _vm.type : null},[_vm._v(_vm._s(_vm.$t(_vm.text)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }